module.exports = __webpack_public_path__ + "static/c1-1d28fe09b86367c3dd5cee39a6b24307.png";